import dashboard from "./dashboard";
import smarttyping from "./smarttyping";
import admin from "./admin";
import guide from "./guide";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, smarttyping, admin, guide],
};

export default menuItems;
